<div  [ngClass]="{'active': isActive}" class="action-button {{ mode }}">
  <div class="action-icon">
    <img [src]=" isShuffled ? '/assets/icons/shuffle.svg' : icon" [alt]="alt"/>
  </div>
  <p class="action-text">{{translationKey | translate}}</p>
</div>

